"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Card = _interopRequireDefault(require("../../../Card"));

var _Header = _interopRequireDefault(require("../../../Card/Header"));

var _Image = _interopRequireDefault(require("../../../Card/Image"));

var _FontAwesome = _interopRequireDefault(require("../../../Icon/FontAwesome"));

var _InfoCard = _interopRequireDefault(require("../InfoCard"));

var _constants = require("./constants");

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * `SideBar` for the `MapMoment` to provide location information.
 */
function MapSideBar(props) {
  var children = props.children,
      currentLocation = props.currentLocation,
      data = props.data,
      onSelect = props.onSelect,
      open = props.open;
  var classes = (0, _constants.useStyles)();
  var theme = (0, _styles.useTheme)();

  var handleSelectLocation = function handleSelectLocation(location) {
    return onSelect(location);
  };

  return _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement(_core.CssBaseline, null), _react.default.createElement("main", {
    className: (0, _clsx2.default)(classes.content, _defineProperty({}, classes.contentShift, open))
  }, children), _react.default.createElement(_core.Drawer, {
    className: classes.drawer,
    variant: "persistent",
    anchor: "right",
    open: open,
    classes: {
      paper: classes.drawerPaper
    }
  }, _react.default.createElement(_core.List, null, data.map(function (location, index) {
    return _react.default.createElement(_core.ListItem, {
      button: true,
      onClick: function onClick() {
        return handleSelectLocation(location);
      },
      key: location,
      divider: true
    }, _react.default.createElement(_InfoCard.default, {
      data: location,
      active: currentLocation == location
    }));
  }))));
}

MapSideBar.propTypes = {
  /** Current location to expand its contents */
  currentLocation: _propTypes.default.object,

  /** Information to render for each `MapPin` */
  data: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /** Callback function for when an item is clicked on */
  onSelect: _propTypes.default.func,

  /** Determines if the `SideBar` is visible. */
  open: _propTypes.default.bool.isRequired,

  /** Styling object of the `Card` */
  style: _propTypes.default.object
};
var _default = MapSideBar;
exports.default = _default;